"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var react_1 = require("react");
var identitySelectorFunction = function (state) { return state; };
//
// createStateHook implementation
//
function createStateHook(context, outerSelector) {
    if (outerSelector === void 0) { outerSelector = identitySelectorFunction; }
    function useAppState(selector, props) {
        var _store = react_1.useContext(context);
        var _props = __assign({ deps: [], compare: undefined }, props);
        var state = _store.state;
        var deps = _props.deps;
        var startValue = react_1.useMemo(function () { return getSelectedValue(state, outerSelector, selector); }, __spreadArrays(deps));
        var _a = react_1.useState(startValue), value = _a[0], setValue = _a[1];
        var output$ = react_1.useMemo(function () {
            return new rxjs_1.BehaviorSubject(startValue);
        }, [state]);
        react_1.useEffect(function () {
            var stateSub = _store.state$.subscribe(function (nextStateValue) {
                var nextValue = getSelectedValue(nextStateValue.state, outerSelector, selector);
                output$.next(nextValue);
            });
            var outputSub = output$
                .pipe(operators_1.distinctUntilChanged(_props.compare))
                .subscribe(function (nextStateValue) { return setValue(nextStateValue); });
            return function cleanup() {
                stateSub.unsubscribe();
                outputSub.unsubscribe();
            };
        }, __spreadArrays([output$], deps));
        return value;
    }
    return useAppState;
}
exports.createStateHook = createStateHook;
function getSelectedValue(state, outerSelector, selector) {
    var subState = outerSelector(state);
    var value = selector(subState);
    return value;
}
//# sourceMappingURL=create-state-hook.js.map